import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import colors from '../../assets/theme/colors';

const TimelineClarificationSection = ({
  messages = [],
  onAddDetails = null,
  actionLabel = 'Add more details',
}) => {
  if (!messages.length) return null;

  return (
    <Box
      role="region"
      aria-label="Needs clarification"
      sx={{
        py: 0.8,
        borderTop: `1px solid ${alpha(colors.semantic.line || '#CBD5E1', 0.72)}`,
      }}
    >
      <Typography sx={{ fontSize: '0.82rem', fontWeight: 900, color: colors.semantic.ink }}>
        Needs clarification
      </Typography>
      <Stack spacing={0.35} sx={{ mt: 0.3 }}>
        {messages.map((message) => (
          <Typography
            key={message}
            sx={{ fontSize: '0.8rem', lineHeight: 1.42, color: alpha(colors.semantic.ink, 0.68) }}
          >
            {message}
          </Typography>
        ))}
      </Stack>
      {onAddDetails ? (
        <Button
          variant="text"
          onClick={onAddDetails}
          sx={{
            mt: 0.25,
            minHeight: 30,
            px: 0,
            fontSize: '0.8rem',
            fontWeight: 900,
            textTransform: 'none',
            color: colors.brand.deep,
            '&:hover': { bgcolor: 'transparent', textDecoration: 'underline' },
          }}
        >
          {actionLabel} →
        </Button>
      ) : null}
    </Box>
  );
};

export default TimelineClarificationSection;
